module.exports = __webpack_public_path__ + "img/finance.a114fa16.svg";